export default function companyNameSearchReducer(
    state: any = {
        companyNames: {
            loading: false,
            done: false,
            error: null,
            response: [],
        },
    },
    action: any) {

    switch (action.type) {

        /**
         *     Try to find address list from Postcode
         */
        case 'FIND_COMPANY_NAMES_PENDING': {
            return { ...state, companyNames: { loading: true } }
        }

        case 'FIND_COMPANY_NAMES_REJECTED': {
            return { ...state, companyNames: { loading: false, error: action.payload } }
        }

        case 'FIND_COMPANY_NAMES_FULFILLED': {
            return {
                ...state,
                companyNames: {
                    loading: false, done: true, error: null, response: action.payload.data.searchResults,
                },
            }
        }

        /**
         *     Default
         */
        default: {
            return { ...state }
        }

    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/reducers/company.ts